import React from 'react';
import Layout from '../components/Layout/Layout';
import iqacPdf from '../images/IQAC-activity&reports.pdf';

const IQACPage = () => {
  return (
    <Layout>
      <div id="iqac" className="page-container" style={{ maxWidth: '800px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        <h2 style={{ color: 'var(--primary-blue)', borderBottom: '2px solid var(--light-blue)', paddingBottom: '10px', marginBottom: '20px' }}>
          Internal Quality Assurance Cell (IQAC)
        </h2>
        <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
          <p style={{ color: '#555', marginBottom: '15px', lineHeight: '1.8' }}>
            The IQAC is established to develop a system for conscious, consistent and catalytic improvement in the overall performance of institutions.
          </p>
          <iframe src={iqacPdf} width="100%" height="800px" title="IQAC Reports" style={{ border: 'none', backgroundColor: '#f0f0f0', marginTop: '20px' }} />
        </div>
      </div>
    </Layout>
  );
};

export default IQACPage;
